import { render, staticRenderFns } from "./ClimbingStyleCragChips.vue?vue&type=template&id=badf0784"
import script from "./ClimbingStyleCragChips.vue?vue&type=script&lang=js"
export * from "./ClimbingStyleCragChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports